/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Branch_Client_Not_CompanyInputs */

const en_api_error_branch_client_not_company = /** @type {(inputs: Api_Error_Branch_Client_Not_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branches can only be created under company clients.`)
};

const pt_br2_api_error_branch_client_not_company = /** @type {(inputs: Api_Error_Branch_Client_Not_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filiais só podem ser criadas para clientes do tipo empresa.`)
};

/**
* | output |
* | --- |
* | "Branches can only be created under company clients." |
*
* @param {Api_Error_Branch_Client_Not_CompanyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_branch_client_not_company = /** @type {((inputs?: Api_Error_Branch_Client_Not_CompanyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Branch_Client_Not_CompanyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_branch_client_not_company(inputs)
	return pt_br2_api_error_branch_client_not_company(inputs)
});